import {
  INVITE_RESENT,
  INVITED_CAREGIVER,
  LLUActions,
  LLUState,
  LOADED_CONNECTIONS,
  LOADED_PENDING_CONNECTIONS,
  REMOVE_CONNECTION,
  REMOVE_PENDING_CONNECTION,
} from './types';

const initialState: LLUState = {
  connections: [],
  pending: [],
  recentlyDeclined: [],
  recentlyInvited: [],
};

export const lluReducer = (state = initialState, action: LLUActions): LLUState => {
  switch (action.type) {
    case INVITE_RESENT:
      return {
        ...state,
        recentlyInvited: [...state.recentlyInvited, action.inviteId],
      };

    case INVITED_CAREGIVER:
      return {
        ...state,
        pending: [...state.pending, action.invitation],
        recentlyInvited: [...state.recentlyInvited, action.invitation.id],
      };

    case LOADED_CONNECTIONS:
      // Only display connected connections
      const connections = action.connections.filter((c) => c.Status === 2);

      return {
        ...state,
        connections: connections,
      };

    case LOADED_PENDING_CONNECTIONS:
      const pending = [...action.pending];

      return {
        ...state,
        // Only display pending invitations
        // Avoid loading recently declined invitations if the server is out of sync
        pending: pending.filter((p) => p.status === 0 && !state.recentlyDeclined.includes(p.id)),
      };

    case REMOVE_CONNECTION:
      return state;

    case REMOVE_PENDING_CONNECTION:
      return {
        ...state,
        pending: state.pending.filter((p) => p.id !== action.invitationId),
        recentlyDeclined: [...state.recentlyDeclined, action.invitationId],
      };

    default:
      return state;
  }
};
